export enum MessageProjectCategory {
  PatentProsecution = 'PATENT_PROSECUTION',
  LegalTranslation  = 'LEGAL_TRANSLATION'
}
